import { Dialog, useMobileBreakpoint } from '@customink/pigment-react';
import type { DialogProps } from '@customink/pigment-react/lib/components/Dialog';
import type {
  Product,
  ProjectItem,
} from '@customink/project-service-react-components';
import { useDesign } from '@customink/project-service-react-components';

import { EditGroupSizesForm } from './EditGroupSizesForm';
import { EditGroupSizesModalSkeleton } from './EditGroupSizesModalSkeleton';

import { googleAnalyticsTag } from '@/components/vendors/googleAnalytics';

type EditGroupSizesModalProps = {
  designCid: string;
  isOpen: boolean;
  projectItems: ProjectItem[];
  products: Product[];
  onClose: () => void;
  onUpdate: () => void;
};

export function EditGroupSizesModal({
  designCid,
  isOpen,
  projectItems,
  products,
  onClose,
  onUpdate,
}: EditGroupSizesModalProps) {
  const isMobile = useMobileBreakpoint();
  const { data: design } = useDesign(designCid);
  const handleClose: DialogProps['onClose'] = (_, reason) => {
    // we want to fire the tag if the user clicks the background of the modal
    if (reason === 'backdropClick') {
      googleAnalyticsTag({
        event: 'edit_sizes_modal',
        edit_sizes_modal_interaction: 'close background click',
      });
    }

    onClose();
  };

  return (
    <Dialog
      data-design-cid={designCid}
      data-testid="edit-sizes-modal"
      hideCloseButton
      onClose={handleClose}
      open={isOpen}
      padding={{
        paddingBottom: isMobile ? '1rem' : '1.5rem',
        paddingLeft: isMobile ? '1rem' : '1.5rem',
        paddingRight: isMobile ? '1rem' : '1.5rem',
        paddingTop: 0,
      }}
      scroll="content"
      title={false}
      titleSx={{ height: 0 }}
      width="lg"
    >
      {products.length > 0 && projectItems.length > 0 && design ? (
        <EditGroupSizesForm
          design={design}
          onClose={onClose}
          onUpdate={onUpdate}
          products={products}
          projectItems={projectItems}
        />
      ) : (
        <EditGroupSizesModalSkeleton numberOfItems={projectItems.length} />
      )}
    </Dialog>
  );
}
